module.exports = __webpack_public_path__ + "img/coin-DASH.757bf936.svg";